// Work anniversaries for the team calendar.
// People come from /api/users/anniversaries as { id, name, smonth, sday, syear }.
// An anniversary shows on the same day and month each year from the FIRST
// anniversary on: never on the start day itself and never before it. Someone
// who started on 29 February shows on 28 February in years without one.

const isLeapYear = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;

export const anniversariesOn = (people, day) => {
  const year = day.getFullYear();
  const month = day.getMonth() + 1;
  const date = day.getDate();
  return people
    .filter((p) => {
      if (year - p.syear < 1) return false;
      if (p.smonth === month && p.sday === date) return true;
      return p.smonth === 2 && p.sday === 29 && month === 2 && date === 28 && !isLeapYear(year);
    })
    .map((p) => {
      const years = year - p.syear;
      return { id: p.id, name: p.name, years, label: `${p.name}, ${years} ${years === 1 ? 'year' : 'years'}` };
    });
};
